export const takeFirstErrorsFromMeta = (meta: { [key: string]: string[] }) =>
  Object.keys(meta).reduce((accumulated, key) => ({ ...accumulated, [key]: meta[key][0] }), {})
